const headerOpener = document.getElementById("js-category-header-content")
const headerContent = document.querySelector(".category__header")

if(headerOpener) {
   headerOpener.addEventListener("click", () => {
    headerOpener.classList.toggle("category__opener--open");
    headerContent.classList.toggle("category__header--open");
   })
}